<script>
import Page from '@/views/Page'
export default {
	name: 'projectpage',
    mixins: [Page],
    created() {
        this.requestData()
    },
    mounted() {
        window.scroll(0, 0)
    }
}
</script>
